import Billing from '@/modules/perseo-billing/billing';
import usePerseoBillingPageInitializer from '@/Pages/PerseoBillingPage/usePerseoBillingPageinitializer';

export const PerseoBillingPage = () => {
  usePerseoBillingPageInitializer();
  return <Billing />;
};
